import { Outlet, useLocation, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuth0();

  const location = useLocation();

  if (!isLoading && !isAuthenticated && location.pathname !== "/")
    return <Navigate to={`${process.env.PUBLIC_URL}`} />;

  const classNames = [
    "col-span-1",
    "col-span-2",
    "col-span-3",
    "col-span-4",
    "col-span-5",
    "col-span-6",
  ];

  return isLoading ? (
    <div className="border border-gray-200 shadow rounded-md p-4 mt-24 max-w-screen-2xl w-9/12 mx-auto">
      <div className="animate-pulse">
        {[1, 2, 3, 4, 5, 6, 7].map((item) => {
          const span = Math.floor(Math.random() * 5);
          return (
            <div className="space-y-3 py-3" key={item}>
              <div className="h-2 bg-slate-200 rounded"></div>
              <div className="grid grid-cols-7 gap-4">
                <div
                  className={`h-2 bg-slate-200 rounded ${classNames[3 - span]}`}
                ></div>
                <div
                  className={`h-2 bg-slate-200 rounded ${classNames[span]}`}
                ></div>
                <div
                  className={`h-2 bg-slate-200 rounded ${classNames[3 - span]}`}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <Outlet />
  );
}
